// extracted by mini-css-extract-plugin
export var chevron = "_2e-d";
export var disabled = "_2e-b";
export var error = "_2e-c";
export var hideBorder = "_2e-1";
export var icon = "_2e-e";
export var input = "_2e-0";
export var large = "_2e-f";
export var open = "_2e-9";
export var placeholder = "_2e-a";
export var regular = "_2e-5";
export var singleRowInput = "_2e-2";
export var singleSelectInput = "_2e-3 _2e-0";
export var small = "_2e-4";
export var spinnerContainer = "_2e-i";
export var tag = "_2e-7";
export var tagsContainer = "_2e-8";
export var tagsInput = "_2e-6 _2e-0";
export var xSmall = "_2e-g";
export var xxSmall = "_2e-h";